import React from 'react';

import TellCodiWidget from './TellCodiWidget';
import CleaningServiceWidget from './CleaningServiceWidget';
import ConsumablesOrderWidget from './ConsumablesOrderWidget';
import ConsumablesServiceWidget from './ConsumablesServiceWidget';
import FurnitureOrderWidget from './FurnitureOrderWidget';
import FurnitureServiceWidget from './FurnitureServiceWidget';
import SupportTicketWidget from './SupportTicketWidget';
import WeatherWidget from './WeatherWidget';
import { DashboardWidgetConfig, WidgetVariant } from './types';

interface Props {
  widgetConfig: DashboardWidgetConfig;
  variant: WidgetVariant;
}

const Widget: React.FC<Props> = ({ widgetConfig: { type, data }, variant }) => {
  switch (type) {
    case 'support_ticket':
      return <SupportTicketWidget data={data} />;
    case 'ai_prompt':
      return <TellCodiWidget variant={variant} />;
    case 'cleaning_service_cta':
      return <CleaningServiceWidget />;
    case 'consumables_service_cta':
      return <ConsumablesServiceWidget variant={variant} />;
    case 'furniture_service_cta':
      return <FurnitureServiceWidget variant={variant} />;
    case 'furniture_order':
      return <FurnitureOrderWidget data={data} />;
    case 'consumables_order':
      return <ConsumablesOrderWidget data={data} variant={variant} />;
    case 'office_weather':
      return <WeatherWidget data={data} />;

    default:
      return null;
  }
};

export default Widget;
